<template>
  <div class="filterbar">
    <div class="filterbar-title py-2">
      <v-row class="title-ul">
        <v-col :cols="12/options.length" :class="`${index=== 0 ? '' : 'px-0'} text-center`" v-for="(item, index) in options" :key="index">
          <span @click="handerClickMenu(item)" class="size-14">
            <span :class="`${item.data.filter((i) => i.selected).length > 0 ? 'primary--text' : ''}`">
              {{item.name}}
            </span>
            <v-icon class="mt-n1" :color="`${item.data.filter((i) => i.selected).length > 0 ? 'primary' : ''}`">{{item.isShow ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
          </span>
          <v-expand-transition>
            <div class="filterbar-content" v-on:click.stop v-if="item.isShow">
              <v-card-title
                v-for="(child, number) in item.data"
                :key="number"
                :class="{'rounded-sm primary--text': child.selected, 'size-14 py-0 px-2 mb-1': true}"
                @click="handerClickContent(item, child)"
                >
                {{child.name || child.label}}
                <v-spacer></v-spacer>
                <v-icon  color="primary" v-if="child.selected">mdi-check-circle</v-icon>
              </v-card-title>
              <v-row v-if="item.multiple">
                <v-col cols="12">
                  <v-btn depressed block @click="handerClear(item)">清空</v-btn>
                </v-col>
                <!-- <v-col cols="6">
                  <v-btn color="primary" depressed block @click="search">确定</v-btn>
                </v-col> -->
              </v-row>
            </div>
          </v-expand-transition>
        </v-col>
      </v-row>
    </div>
    <div class="bg-filterbar" v-if="isBgFilterbarShow" @click="handerClickMenu"></div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      checked: {}
    }
  },
  computed: {
    isBgFilterbarShow: {
      get() {
        let isBgShow = false;
        this.options.forEach((currentValue) => {
          if (currentValue.isShow) {
            isBgShow = true
          }
        })
        return isBgShow
      }
    }
  },
  methods: {
    search() {
      this.handerClose()
      this.$emit('on-change', this.checked)
    },
    handerClose() {
      this.options.forEach((currentValue) => {
        currentValue.isShow = false
      })
    },
    handerClickMenu(item) {
      if (!item) {
        return
      }
      this.options.forEach((currentValue) => {
        this.setChecked(item)
        if (currentValue.value === item.value) {
          currentValue.isShow = !currentValue.isShow
        } else {
          currentValue.isShow = false
        }
      })
    },
    handerClickContent(item, child) {
      this.setChecked(item)
      if (!item.multiple) {
        this.handerClear(item)
        this.handerClose(item)
      }
      child.selected = !child.selected
      if (item.multiple) {
        if (child.selected) {
          this.checked[item.secKey].push(child.value)
        } else {
          this.checked[item.secKey].remove(child.value)
        }
      } else if (child.selected) {
        this.checked[item.secKey] = child.value
      } else {
        this.checked[item.secKey] = ''
      }
      this.$emit('on-change', this.checked)
    },
    handerClear(item) {
      item.data.forEach((currentValue) => {
        currentValue.selected = false
      })
      this.chencked = {}
    },
    setChecked (item) {
      if (item.multiple) {
        if (!this.checked[item.secKey]) {
          this.checked[item.secKey] = []
        }
      } else if (!this.checked[item.secKey]) {
        this.checked[item.secKey] = ''
      }
    }
  },
  created () {
    this.options.forEach((item) => {
      this.setChecked(item)
      item.data.forEach(child => {
        if (child.selected) {
          if (item.multiple) {
            this.checked[item.secKey].push(child.value)
          } else {
            this.checked[item.secKey] = child.value
          }
        }
      })
    })
    this.$emit('on-change', this.checked)
  }
}
</script>

<style lang="less">
.filterbar {
  position: fixed;
  z-index: 2;
  left: 0;
  top: 3.1em;
  width: 100%;
  background-color: #fff;
  height: 2.5em;
  .bg-filterbar {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.2;
    z-index: 1;
    left: 0;
    top: 6em;
  }
  .filterbar-title {
    width: 100%;
    .title-ul {
      padding-left: 0px;
      height: 2.8em;
      border-bottom: 1px solid #eee;
    }
    .filterbar-content {
      position: absolute;
      left: 0;
      width: 100%;
      padding: 0.5em;
      background-color: #fff;
      z-index: 2;
      top: 2.5em;
      .v-list-item {
        min-height: 0px;
        height: 35px;
      }
    }
  }
}
</style>